<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">
                        {{ $t('words.duplicate_block') }}<span class="page-header-breadcrumb">></span>{{ $t('words.duplicate_block_manage') }}
                        <small class="text--caption">({{ currentDuplicateBlockPolicyDesc }})</small>
                    </h3>
                </div>
                <ul class="nav nav-tab nav--tab" id="childTab" role="tablist">
                    <li class="nav-item">
                        <router-link class="nav-link" id="duplicate_block_sessions-nav" :to="{ name: 'cms-preferences-duplicate_block_sessions' }" aria-controls="duplicate_block_sessions" aria-selected="false">{{ $t('words.duplicate_block_sessions') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="duplicate_block_logs-nav" :to="{ name: 'cms-preferences-duplicate_block_logs' }" aria-controls="duplicate_block_logs" aria-selected="false">{{ $t('words.duplicate_block_logs')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link active" id="duplicate_block_manage-nav" :to="{ name: 'cms-preferences-duplicate_block_manage' }" aria-controls="duplicate_block_manage" aria-selected="false">{{ $t('words.duplicate_block_manage') }}</router-link>
                    </li>
                </ul>
            </div>

            <section class="content">
                <section class="row">
                    <section class="col-md-12">
                        <div class="tile">
                            <div class="tile__header">
                                <form @submit.prevent="doResetPlayer">
                                    <label class="form--label" for="resetKeyword">{{ $t('words.duplicate_block_reset_all_player_id') }}</label>
                                    <div class="input-group">
                                        <input type="text" id="resetKeyword" class="form-control form__search" :placeholder="$t('words.client_user_id')" v-model="resetClientUserId">
                                        <button type="submit" class="btn" v-if="haveSubmitRight">
                                            {{ $t('words.reset') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>

                    <section class="col-md-6">
                        <div class="tile">
                            <div class="tile__header">
                                <label class="form--label" for="searchClientUserId">
                                    {{ $t('words.duplicate_block_delete_player_id') }}
                                </label>
                                <form class="input-group" @submit.prevent="loadPlayers">
                                    <input type="text" id="searchClientUserId" class="form-control form__search" :placeholder="$t('words.client_user_id')" v-model="searchClientUserId">
                                    <button type="submit" class="btn">
                                        {{ $t('words.search') }}
                                    </button>
                                </form>
                            </div>
                            <div class="tile__body">
                                <table class="table table-wide">
                                    <thead>
                                    <tr>
                                        <th>{{ $t('words.player_id')}}</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="players.is_loaded && (players.data.length > 0)">
                                    <tr v-for="(player, index) in players.data" :key="index">
                                        <td>{{ player }}</td>
                                        <td class="cell--action">
                                            <button class="btn--icon btn--icon--sm"  @click="doUnregisterPlayer(index, searchClientUserId, player)">
                                                <i class="icon icon-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else-if="players.is_loaded">
                                    <tr>
                                        <td colspan="2" class="td__message">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <tr>
                                        <td colspan="2" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                    <div class="col-md-6">
                        <div class="tile">
                            <div class="tile__header">
                                <label class="form--label" for="searchPlayerId">{{ $t('words.duplicate_block_delete_client_user_id') }}</label>
                                <form class="input-group" @submit.prevent="loadClients">
                                    <input type="text" id="searchPlayerId" class="form-control form__search" :placeholder="$t('words.player_id')" v-model="searchPlayerId">
                                    <button type="submit" class="btn">
                                        {{ $t('words.search') }}
                                    </button>
                                </form>
                            </div>
                            <div class="tile__body">
                                <table class="table table-wide">
                                    <thead>
                                    <tr>
                                        <th>{{ $t('words.client_user_id')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="clients.is_loaded && (clients.data.length > 0)">
                                    <tr v-for="(client, index) in clients.data" :key="index">
                                        <td>{{ client }}</td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else-if="clients.is_loaded">
                                    <tr>
                                        <td colspan="1" class="td__message">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <tr>
                                        <td colspan="1" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

const DUPLICATE_BLOCK_POLICIES = {
    NOT_ALLOWED: 'not used',
    ALLOW_ONE_DEVICE_AT_SAME_TIME: 'allow_one_device_at_same_time',
    ALLOW_REGISTERED_DEVICE: 'allow_registered_device',
    ALLOW_REGISTERED_ONE_DEVICE_AT_SAME_TIME: 'allow_registered_one_device_at_same_time',
};

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            players: {
                data: [],
                is_loaded: true,
            },
            clients: {
                data: [],
                is_loaded: true,
            },
            searchClientUserId: '',
            resetClientUserId: '',
            searchPlayerId: '',
        };
    },
    beforeMount() {
    },
    mounted() {
    },
    methods: {
        doResetPlayer() {
            if (!this.haveSubmitRight) {
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.duplicate_block_player_reset'))) {
                axios.delete(`/cms/${this.selectedServiceAccount.key}/duplicate_block/player/reset`, {
                    data: {
                        client_user_id: this.resetClientUserId,
                    },
                }).then(() => {
                    this.resetClientUserId = '';
                    this.$toasted.success(this.$t('paragraphs.message.success.duplicate_block_player_reset'));
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.duplicate_block_player_reset'));
                });
            }
        },
        doUnregisterPlayer(index, clientUserId, player) {
            if (!this.haveSubmitRight) {
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.duplicate_block_player_unregister'))) {
                axios.delete(`/cms/${this.selectedServiceAccount.key}/duplicate_block/player/unregister`, {
                    data: {
                        client_user_id: clientUserId,
                        player_id: player,
                    },
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.duplicate_block_player_unregister'));
                    this.loadPlayers();
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.duplicate_block_player_unregister'));
                });
            }
        },
        loadPlayers() {
            if (_.isEmpty(this.searchClientUserId)) {
                this.players.data = [];
                this.players.is_loaded = true;
                return;
            }
            this.players.is_loaded = false;
            axios.get(`${this.playersApi}?client_user_id=${encodeURI(this.searchClientUserId)}`).then((response) => {
                if (response.data.response.result) {
                    this.players.data = response.data.response.result;
                } else {
                    this.players.data = [];
                }
                this.players.is_loaded = true;
            }).catch((error) => {
                this.players.is_loaded = true;
            });
        },
        loadClients() {
            if (_.isEmpty(this.searchPlayerId)) {
                this.clients.data = [];
                this.clients.is_loaded = true;
                return;
            }
            this.clients.is_loaded = false;
            axios.get(`${this.clientsApi}?player_id=${encodeURI(this.searchPlayerId)}`).then((response) => {
                if (response.data.response.result) {
                    this.clients.data = response.data.response.result;
                } else {
                    this.clients.data = [];
                }
                this.clients.is_loaded = true;
            }).catch((error) => {
                this.clients.is_loaded = true;
            });
        },
    },
    computed: {
        playersApi() {
            return `/cms/${this.selectedServiceAccount.key}/duplicate_block/players`;
        },
        clientsApi() {
            return `/cms/${this.selectedServiceAccount.key}/duplicate_block/clients`;
        },
        currentDuplicateBlockPolicy() {
            if (this.selectedServiceAccount && this.selectedServiceAccountContract) {
                return this.selectedServiceAccountContract.duplicate_block_policy;
            }
            return {};
        },
        currentDuplicateBlockPolicyDesc() {
            if (_.isEmpty(this.currentDuplicateBlockPolicy)) {
                return '';
            }
            const policy = this.currentDuplicateBlockPolicy;
            if (policy === 'not used') {
                return '';
            }
            return this.$t(`words.duplicate_block_policy_${policy}`);
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
    },
    watch: {
    },
};
</script>

<style scoped>
    .table .thead {
        width: 25%;
    }

    .table-wide {
        border-top: 0;
    }
</style>
